import type { WorkerStatus } from "@/api/tenants";
import { Pill } from "@/components/ui";
import { t } from "@/i18n";
import { fmtDateTime } from "@/lib/utils";

interface WorkerHealthProps {
  worker: WorkerStatus;
}

/** vdd_settings.worker_heartbeat uzerinden worker canliligi (gorev talimati
 * madde 5 "worker sagligi") — `.kpi` (ust vurgu cizgisi: canli yesil, degilse
 * kirmizi), KpiCard'in kendi desenini izler (label+Pill ustte, ozet altta). */
export function WorkerHealth({ worker }: WorkerHealthProps) {
  return (
    <div className={`kpi ${worker.alive ? "kpi-ok" : "kpi-bad"}`}>
      <div className="flex items-start justify-between gap-2">
        <h2 className="kpi-lbl pr-1">{t("admin.worker.title")}</h2>
        <Pill tone={worker.alive ? "ok" : "bad"}>{worker.alive ? t("admin.worker.alive") : t("admin.worker.dead")}</Pill>
      </div>
      <p className="kpi-sub mt-2">
        {worker.last_seen ? t("admin.worker.last_seen", { time: fmtDateTime(worker.last_seen) }) : t("admin.worker.never")}
      </p>
    </div>
  );
}
